export class ActivateGcpOrganizationResponse {
    'gcpOrganization';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpOrganization",
            "baseName": "gcpOrganization",
            "type": "GcpOrganization",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ActivateGcpOrganizationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
